<template>
    <div class="rating-widget">
        <div class="rating-area">
            <div class="rating-header pb-4">
                <h2 class="title font-weight-light" v-if="userDetails">Rate {{userDetails.username}}</h2>
            </div>
            <div class="rating-star-area">
                <div class="rating-icon-wrapper">
                    <icon-svg icon="star-group" :size="120" :fill="transitionColor"></icon-svg>
                    <div class="label "> x
                        <transition :name="labelTransition">
                            <span class="label-text headline error--text" v-if="reviewRate <= 10" key="label-0">0</span>
                            <span class="label-text headline error--text" v-else-if="reviewRate <= 20" key="label-1">1</span>
                            <span class="label-text headline blue--text" v-else-if="reviewRate <= 40" key="label-2">2</span>
                            <span class="label-text headline blue--text" v-else-if="reviewRate <= 60" key="label-3">3</span>
                            <span class="label-text headline blue--text" v-else-if="reviewRate <= 80" key="label-4">4</span>
                            <span class="label-text headline starColor--text" v-else-if="reviewRate <= 100" key="label-5">5</span>
                        </transition>
                    </div>
                </div>
            </div>
            <!-- feedback area -->
            <v-fade-transition mode="out-in">
                <div class="rating-feedBack" v-if="reviewRate > 80" key="fb-awesome">
                    <feedback-msg thrilled>
                        <template v-slot:message><span class="font-weight-light title">Awesome!</span></template>
                    </feedback-msg>
                </div>
                <div class="rating-feedBack" v-else-if="reviewRate < 20" key="fb-sad">
                    <feedback-msg sad>
                        <template v-slot:message><span class="font-weight-light title">Sad!</span></template>
                    </feedback-msg>
                </div>
                <div class="rating-feedBack" v-else key="fb-thanks">
                    <feedback-msg thanks>
                        <template v-slot:message><span class="font-weight-light title">Thanks!</span></template>
                    </feedback-msg>
                </div>
            </v-fade-transition>
            <!-- slider actions -->
            <div class="rating-action">
                <v-slider 
                v-model="reviewRate" 
                hide-details 
                thumb-label 
                thumb-size=40 
                @start="onDragStart" 
                @end="onDragEnd" 
                class="rate-slider my-3" 
                track-color="grey" 
                :color="transitionColor">
                    <template v-slot:thumb-label="{ value }">
                        {{ satisfactionEmojis[Math.min(Math.floor(value / 10), 9)] }}
                    </template>
                </v-slider>
            </div>
            <v-btn text absolute right bottom><v-icon left color="grey">mdi-thumb-up</v-icon> Rate</v-btn>
        </div>
    </div>
</template>
<style scoped>
.rating-widget {
  width: 100%;
  display: block;
  overflow: hidden;
}
.rating-area {
    width: 100%;
    padding: 0 20px;

}

.rating-header {
    text-align: center;
}

.rating-star-area {
    display: flex;
    justify-content: center;
}

.rating-icon-wrapper {
    display: inline-flex;
    align-items: center;
}

.label {
    width: 30px;
    height: 30px;
    position: relative;
    padding-left: 5px;
}

.label-text {
    position: absolute;
    right: 0;
    display: inline-block;
}
</style>
<script>
import feedbackMsg from "@/components/animation-banners/animation-feedback.vue"
export default {
    props: {
        userDetails: Object
    },
    components: {
        'feedback-msg': feedbackMsg
    },
    data() {
        return {
            reviewRate: 30,
            currentRate: this.reviewRate,
            satisfactionEmojis: ['😭', '😢', '☹️', '🙁', '😐', '🙂', '😊', '😁', '😄', '😍'],
            labelTransition: 'scale-in'
        }
    },

    methods: {
        onDragStart() {
            //console.log(Math.min(Math.floor(val / 10), 9))
        },

        onDragEnd() {
            //console.log(Math.min(Math.floor(val / 10), 9))
        },

        changeTransition(val) {
            let transition = null
            if (this.currentRate > val) {
                transition = "scale-out"
            } else {
                transition = "scale-in"
            }
            this.labelTransition = transition
        }
    },

    computed: {
      transitionColor() {
        if(this.reviewRate < 20) {
          return this.$vuetify.theme.themes.light.error
        } else if(this.reviewRate > 80) {
          return this.$vuetify.theme.themes.light.starColor
        } else {
          return this.$vuetify.theme.themes.light.textLinks
        }
      }
    },

    watch: {
        'reviewRate'(val) {

            this.changeTransition(val)

            this.currentRate = val
        }
    }
}
</script>